/*
 * @format
 * @flow
 */

import * as React from 'react';
import styled, {css} from 'styled-components';
import {useTranslation} from 'react-i18next';
import {notWebMediaQuery} from '../../styles';

const RecentGameItem = props => {
    let {t} = useTranslation();

    const _onPress = () => {
        props.handleClickGame(props.game.id, props.game);
    };
    return (
        <Container
            width={props.width}
            activeScale={1.03}
            friction={10.0}
            onClick={_onPress}
            gutter={props.gutter}
            brand={props.brand}
        >
            <Image src={props.game.image} brand={props.brand} />
            <TextHolder>
                <TextTitle brand={props.brand}>{props.game.title}</TextTitle>
                <TextSerie brand={props.brand}>{props.game.showName}</TextSerie>
            </TextHolder>
            <ButtonPlay brand={props.brand}>{t('games.playCTA')}</ButtonPlay>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    background-color: #211921;
    width: ${props => props.width}px;
    flex-direction: row;
    height: 89px;
    align-items: center;
    margin-right: ${props => props.gutter}px;
    cursor: pointer;
    ${props =>
        props.brand === 'dkids' &&
        css`
            height: 96px;
            background: #121f97;
            border-radius: 20px;
        `};
    :last-child {
        margin-right: 0px;
    }

    ${notWebMediaQuery} {
        height: 77px;
    }
`;

const TextHolder = styled.div`
    flex: 1;
    padding: 0px 14px;
`;

const TextTitle = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    max-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: white;
    text-transform: uppercase;

    ${props =>
        props.brand === 'dkids' &&
        css`
            font-family: Mont;
            font-weight: 300;
        `}

    ${notWebMediaQuery} {
        font-size: 12px;
        line-height: 14px;
    }
`;

const TextSerie = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 15px;
    max-height: 30px;
    color: white;
    margin-top: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;

    ${props =>
        props.brand === 'dkids' &&
        css`
            font-family: Mont;
            font-weight: 100;
        `}

    ${notWebMediaQuery} {
        font-size: 12px;
        line-height: 13px;
        margin-top: 4px;
    }
`;

const Image = styled.img`
    width: 114px;
    height: 61px;
    border-radius: 6px;
    overflow: hidden;
    margin-left: 15px;
    object-fit: cover;

    ${props =>
        props.brand === 'dkids' &&
        css`
            border-radius: 14px;
            width: 121px;
            height: 68px;
        `};

    ${notWebMediaQuery} {
        width: 91px;
        height: 50px;
    }
`;

const ButtonPlay = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    text-align: center;
    color: white;
    padding: 8px 15px;
    background-color: rgba(255, 255, 255, 0.18);
    border-radius: 16px;
    overflow: hidden;
    text-transform: uppercase;
    margin-right: 15px;
    flex-shrink: 0;

    ${props =>
        props.brand === 'dkids' &&
        css`
            background-color: #2852b0;
            border-radius: 60px;
            padding: 12px 16px 10px 16px;
            font-family: DKIDS;
            font-size: 14px;
        `}
`;

export default RecentGameItem;
